import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ShieldCheck, HeartPulse, Brain, PersonStanding, Sparkles, Droplets, Apple, Users,
} from "lucide-react";
import { PROGRAMS } from "@/lib/constants";

const SLUG_ICONS = {
  "prevention-longevity": ShieldCheck,
  "rehab-recovery": HeartPulse,
  "mental-wellbeing": Brain,
  "slimming-metabolic-reset": PersonStanding,
  "anti-ageing-kayakalp": Sparkles,
  "skin-hair-body-wellness": Droplets,
  "nutrition-products": Apple,
  "community-wellness": Users,
};

export default function ProgramsGrid() {
  return (
    <section id="programs" data-testid="programs-section" className="relative bg-[#050505] overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[1480px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="font-serif-display text-4xl sm:text-5xl text-center"
        >
          <span className="text-[#f7f2e8]">Our Core </span>
          <span className="text-[#c9a14a]">Wellness Programs</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4">
          {PROGRAMS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 8) * 0.08 }}
              className="relative group pt-5"
            >
              <Link to={`/programs/${p.slug}`} data-testid={`program-card-${i}`} className="block h-full">
                <span className="absolute top-0 left-1/2 -translate-x-1/2 z-10 w-10 h-10 rounded-full bg-[#c9a14a] border-2 border-[#050505] flex items-center justify-center shadow-lg text-[#050505]">
                  {(() => {
                    const Icon = SLUG_ICONS[p.slug] || Sparkles;
                    return <Icon size={17} strokeWidth={1.8} />;
                  })()}
                </span>
                <div className="border border-[#c9a14a]/25 rounded-lg overflow-hidden bg-[#0b0b0b] transition-colors duration-500 group-hover:border-[#c9a14a]/60 h-full flex flex-col">
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={p.image}
                      alt={p.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                    />
                  </div>
                  <p className="text-center text-[12px] font-semibold text-[#f7f2e8] leading-snug px-2 py-4">
                    {p.title}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-14 flex justify-center"
        >
          <Link to="/programs" data-testid="explore-all-programs-button" className="btn-outline-gold">
            Explore All Programs
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
